import { Inject, Injectable } from '@angular/core';
import { DataService } from 'ag-common-svc/lib/services/data.service';
import { FIREBASE_APP } from 'ag-common-svc/lib/injections/firebase-app';
import { FirebaseApp } from 'firebase/app';
import {
  Template,
  TemplateKeys, TemplateSubTypes,
  TemplateTypes,
} from '../components/administration/template-builder/template-editor-page/models';
import { QueryParam, WhereFilterOperandKeys } from 'ag-common-svc/lib/dao/CommonFireStoreDao.dao';

@Injectable({
  providedIn: 'root',
})
export class TemplatesService extends DataService<Template> {
  private readonly templatesCollectionPath = 'templates';

  constructor(@Inject(FIREBASE_APP) fireBaseApp: FirebaseApp) {
    super(fireBaseApp, null, TemplatesService.toFirestore);
    super.setCollection(this.templatesCollectionPath);
  }

  static readonly toFirestore = (data): Template => {
    return JSON.parse(JSON.stringify(data));
  };

  getTemplatePagesList = () => {
    const qp: QueryParam[] = [
      new QueryParam(TemplateKeys.type, WhereFilterOperandKeys.equal, TemplateTypes.page),
      new QueryParam(TemplateKeys.subtype, WhereFilterOperandKeys.equal, TemplateSubTypes.page),
    ];

    return this.getList(qp, { sortField: TemplateKeys.name });
  };
}
